"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppQuota = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const application_host_1 = require("../common/application-host");
const cache_1 = __importDefault(require("../helper/cache"));
const character_1 = require("../services/character");
const useRequest_1 = __importDefault(require("./useRequest"));
const useAppQuota = () => {
    const { request } = (0, useRequest_1.default)();
    // const activeSubscription = useSelector(
    //   (state: RootState) => state.subscriptionPlan.subscription
    // );
    const messageQuota = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan.quota?.conversations);
    const characterQuota = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan.quota?.characters);
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const increaseUserMessageQuota = async () => {
        const quotaCacheKey = `appUserQuota_${application_host_1.ENV_TYPE}`;
        let appUserQuota = await cache_1.default.getItem(quotaCacheKey);
        // User is anonymous and cached quota exists!
        if (appUserQuota && appUserQuota?.uid) {
            const newQuota = appUserQuota.conversations.consumed + 1;
            const anonCacheQuota = {
                // uid: appUser?.id,
                ...appUserQuota,
                conversations: {
                    ...appUserQuota.conversations,
                    consumed: newQuota < 5 ? newQuota : 5,
                },
            };
            await cache_1.default.setItem(quotaCacheKey, anonCacheQuota);
        }
    };
    /**
     *
     */
    const loadUserQuota = (0, react_1.useCallback)(() => (request(character_1.getUserQuota, appUser.id)), [appUser]);
    const consumedMessagesPercent = (0, react_1.useMemo)(() => {
        if (messageQuota?.quota) {
            return (messageQuota.consumed / messageQuota.quota) * 100;
        }
        // no quota
        return 100;
    }, [messageQuota]);
    const messagesQuota = (0, react_1.useMemo)(() => {
        return messageQuota?.quota || 0;
    }, [messageQuota]);
    const pendingMessageCount = (0, react_1.useMemo)(() => {
        if (messageQuota?.quota) {
            return Math.max(messageQuota?.quota - messageQuota.consumed, 0);
        }
        return 0;
    }, [messageQuota, appUser?.id]);
    const pendingCharacterCount = (0, react_1.useMemo)(() => {
        if (characterQuota?.quota) {
            return Math.max(characterQuota?.quota - characterQuota.consumed, 0);
        }
        return 0;
    }, [characterQuota, appUser?.id]);
    const hasPendingMessageQuota = (0, react_1.useMemo)(() => pendingMessageCount > 0, [pendingMessageCount]);
    return {
        loadUserQuota,
        increaseUserMessageQuota,
        pendingMessageCount,
        pendingCharacterCount,
        messagesQuota,
        consumedMessagesPercent,
        hasPendingMessageQuota,
        characterQuota,
    };
};
exports.useAppQuota = useAppQuota;
